export const unauthorized = 'UNAUTHORIZED';
export const notFound = 'NOT_FOUND';
export const notConsultable = 'NOT_CONSULTABLE';
export const talkUserNotMapped = 'TALK_USER_NOT_MAPPED';
export const notAvailableAppkey = 'NOT_AVAILABLE_APPKEY';
export const badResponse = 'BAD_RESPONSE';
export const notVerifiedAgeAuth = 'NOT_VERIFIED_AGE_AUTH';



// WEBPACK FOOTER //
// ./src/constants/ErrorTypes.js